import { useMediaQuery } from "shared/hooks";

export function useShouldRenderSideBySide() {
  return useMediaQuery({
    query: "(min-width: 1100px)",
  });
}
